var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 876,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 877,
	"./assets/thewest-digital-hero-variation-a.jpg": 2947,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 878,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2948,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 879,
	"./assets/thewest-digital-hero-variation-b.jpg": 2949,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 880,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2950,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 881,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2951,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 882,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2952,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 883,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 2953,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 884,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2954,
	"./assets/thewest-digital-hero.jpg": 2955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;